import { ChangeDetectionStrategy, Component, computed, HostBinding, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';


export type IconSizeAlias = 'xs' | 'sm' | 'smd' | 'md' | 'slg' | 'lg' | 'xlg';
export type IconSizeValue = 12 | 14 | 16 | 18 | 20 | 24 | 28;

@Component({
  selector: 'lbt-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  imports: [
    MatTooltip,
    MatIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconComponent {
  private readonly sizes: Record<IconSizeAlias, IconSizeValue> = {
    xs: 12,
    sm: 14,
    smd: 16,
    md: 18,
    slg: 20,
    lg: 24,
    xlg: 28,
  };

  private readonly iconSize = computed<string>(() => `${this.sizes[this.size()]}px`);
  private readonly iconColor = computed<string>(() => `var(--color-${this.color()})` || 'inherit');

  readonly size = input<IconSizeAlias>('md');
  readonly fill= input<boolean>(false);
  readonly color= input<string>('black-6');
  readonly tooltip = input<string>();

  @HostBinding('style.--icon-size')
  get sizeValue(): string {
    return this.iconSize();
  }

  @HostBinding('style.--icon-color')
  get colorValue(): string {
    return this.iconColor();
  }
}
